import { render, staticRenderFns } from "./InstituteChainView.vue?vue&type=template&id=a8079f02"
import script from "./InstituteChainView.vue?vue&type=script&lang=js"
export * from "./InstituteChainView.vue?vue&type=script&lang=js"
import style0 from "./InstituteChainView.vue?vue&type=style&index=0&id=a8079f02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports